import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { I18nContext } from '@bingads-webui-react/i18n-context';
import { ValidatedFormCard, FormCardBasicHeader } from '@bingads-webui-campaign-react/validated-form-cards';
import { FormCardBody } from '@bingads-webui-fluent-component/form-cards';
import { withControlErrorHandling, withUnvalidatedControlErrors } from '@bingads-webui-campaign-react/error-handling';
import { AdGroup } from '@bingads-webui/campaign-odata-schemas';
import { andComp, entityIs, propertyIs } from '@bingads-webui-campaign-react/form-error';
import { ERROR_ENTITY } from '@bingads-webui-campaign-react/linkedin-data';
import { RemainingCharsValidatedTextField } from '@bingads-webui-campaign-react/remaining-chars-hint';

import { AdGroupNameSkeleton } from '../components/skeletons';

const entityIsAdGroup = entityIs(ERROR_ENTITY.AdGroup);
const adGroupNameProp = andComp(entityIsAdGroup, propertyIs('Name'));

const ServerValidatedTextField = withControlErrorHandling(withUnvalidatedControlErrors(RemainingCharsValidatedTextField, { filter: adGroupNameProp }));

export const AdGroupNameCard = ({ data, ...cardProps }) => {
  const i18n = useContext(I18nContext);

  return (
    <ValidatedFormCard {...cardProps}>
      <FormCardBasicHeader
        title={i18n.getString(_TL_('Ad group name'))}
        helpTopic="pop_BA_CampaignCreate_Settings_CampaignName"
      />
      <FormCardBody>
        {data ? (
          <ServerValidatedTextField
            i18n={i18n}
            className="input-adgroup-name"
            validationProps={{ schema: AdGroup, field: 'Name' }}
          />
        ) : (
          <AdGroupNameSkeleton />
        )}
      </FormCardBody>
    </ValidatedFormCard>
  );
};

AdGroupNameCard.propTypes = {
  data: PropTypes.shape({}).isRequired,
};
